import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from './../../Layout/Header1';
import Footer from './../../Layout/Footer1';
import PageTitle from './../../Layout/PageTitle';
import SectionCounter from './../../Element/SectionCounter';
import TestimonialCarousel from './../../Element/TestimonialCarousel';
import FormStyle from './../../Element/FormStyle';

//Images
import bnr1 from './../../../images/banner/bnr4.jpg';
import bgmap from './../../../images/background/bg-map.jpg';
import bg1 from './../../../images/background/bg1.jpg';
import about from './../../../images/about/pic3.jpg';

const iconWraper=[
	{icon: <i className="flaticon-android" />, title:'Android Apps Development', para: 'Your first 25 messages are free and you don\'t have to input any card details to use your free credit. Price does not increase alongside the size of your database - send SMS how you want and only pay for what you use.'},
	{icon: <i className="flaticon-apple" />, title:'iOS App Development', para: 'Your first 25 messages are free and you don\'t have to input any card details to use your free credit. Price does not increase alongside the size of your database - send SMS how you want and only pay for what you use.'},
	{icon: <i className="flaticon-layers" />, title:'React-Native Apps Development', para: 'Your first 25 messages are free and you don\'t have to input any card details to use your free credit. Price does not increase alongside the size of your database - send SMS how you want and only pay for what you use.'},
	{icon: <i className="flaticon-mind" />, title:'Apps Developement on Flutter', para: 'Your first 25 messages are free and you don\'t have to input any card details to use your free credit. Price does not increase alongside the size of your database - send SMS how you want and only pay for what you use.'},
	{icon: <i className="flaticon-operation" />, title:'Re-Build Any Apps', para: 'Your first 25 messages are free and you don\'t have to input any card details to use your free credit. Price does not increase alongside the size of your database - send SMS how you want and only pay for what you use.'},
	{icon: <i className="flaticon-internet" />, title:'Existing App Maintenance', para: 'Your first 25 messages are free and you don\'t have to input any card details to use your free credit. Price does not increase alongside the size of your database - send SMS how you want and only pay for what you use.'},
];

// const titleBlog=[
// 	{title1:'No Upfront Contracts', title2: 'or Hidden Fees', para: 'Your first 25 messages are free and you don\'t have to input any card details to use your free credit. Price does not increase alongside the size of your database - send SMS how you want and only pay for what you use.'}, 
// 	{title1:'Not Another Software', title2: 'Subscription!', para: 'No, whiteBing is pay-as-you-use, you\'re not paying when you\'re not using. So don\'t worry about yet another monthly subscription that you forget about and keep on paying.'}, 
// 	{title1:'100% Uptime', title2: 'SLA Guarantee', para: 'We’re so confident in our reliability, we offer a 100% uptime SLA guarantee so you can be sure your message reaches when you need it to.'}, 
// 	{title1:'Don\'t Stress About', title2: 'Message Deliverability', para: 'Not only is our service always up and running, but we use direct routes. So rest assured when you click send your messages are being delivered on time, every time via the quickest route.'}, 
// 	{title1:'Free 24/7 Support', title2: '365 Days', para: 'Talk to us through live chat, phone, contact form or email. There’s always a human on the other end, ready to help.'}, 
// 	{title1:'Relax, Help Is', title2: 'Always At Hand', para: 'Our global 24/7 chat is industry leading and we\'re proud to employ real humans in support to help our real humans in use. We understand businesses can require quick, efficient support at any time of the day or night.'}, 
// ];

class MobileAppDev extends Component {
    
    render() {

        return (
            <>
                <Header />

                <div className="page-content bg-white">
                    {/* <!-- inner page banner --> */}
                    <div className="dlab-bnr-inr overlay-primary" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
                        <PageTitle motherMenu='Mobile Apps Development' activeMenu='Mobile Apps Development' />
                    </div>
                    {/* <!-- inner page banner END --> */}
                    <div className="content-block">
                        {/* <!-- About Us --> */}
                        <div className="section-full content-inner exp-services">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="section-head text-black text-center">
                                            <h4 className="text-gray-dark font-weight-500 m-b10">Mobile Apps Development</h4>
                                            <h2 className="box-title m-tb0">Get Cross-Platform Compatible Mobile Apps for Android and iOS<span className="bg-primary"></span></h2>
                                            <p className="font-weight-300 font-18">There are over <strong ><a href={"https://www.statista.com/statistics/330695/number-of-smartphone-users-worldwide/"} >6.2 billion smartphone users worldwide</a></strong>, so there is no doubt that the industry is healthy and thriving. Stats are growing steadily, without any indications of slowing down. And studies show that an average world-wide checks their phone at least once every 10 Seconds, and over 10% of these people check their phone about every minute.</p>
                                        </div>
                                        <div className="row serv">
											{iconWraper.map((data,index)=>(	
												<div className="col-lg-2.5 col-md-4 col-sm-6 m-b30" key={index}>
													<div className="icon-bx-wraper expertise  bx-style-1 p-lr10 p-tb20 center">
														<div className="icon-bx-sm bg-primary radius m-b20">
															<Link to={"#"} className="icon-cell">{data.icon}</Link>
														</div>
														<div className="icon-content">
															<h5 className="dlab-tilte"><Link to={"#"}>{data.title}</Link></h5>
														</div>
													</div>
												</div>
											))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- Our Services --> */}
                        {/* <!-- About Us --> */}
                        <div className="section-full">
                            <div className="container-fluid">
                                <div className="row dzseth">
                                    <div className="col-lg-6 col-md-12 p-a0 img-fix">
                                        <img src={about} alt="" className="img-cover" />
                                    </div>
                                    <div className="col-lg-6 col-md-12 bg-black-light p-lr0 dis-tbl">
                                        <div className="p-a30 dis-tbl-cell ">
                                            <div className="max-w500 m-auto p-tb30">
                                                <div className="row">
                                                    <div className="col-lg-12 text-white">
                                                        <h3 className="box-title m-b10">Build Better, Smarter, <br/>More Interactive, Attractive Apps.<span className="bg-primary"></span></h3>
                                                        <h5 className="m-b30">We put disruption in top gear by helping you create exceptional experiences. We help you solve problems at scale and at speed - through transformation aided by technology..</h5>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-12 m-b30 chosesus-content">
                                                        <ul className="list-checked primary text-white">
                                                            <li><span>World-class mobile app development company.</span></li>
                                                            <li><span>Custom iOS and Android apps development.</span></li>
                                                            <li><span>Get Cross-Platform Compatible Native Mobile Apps for Android and iOS</span></li>
                                                        </ul>
                                                        <p>Your dream deserves more than a place in your imagination. Our mobile app developers can build the mobile app to your requirement, in your budget and as per your timeline.</p>
                                                        <p className="list-checked primary text-white">Talk to us through live chat, phone, contact form or email. There’s always a human on the other end, ready to help.</p>
                                                        <Link to={"#"} className="site-button radius-xl outline white">Read More <i className="fa fa-long-arrow-right"></i></Link>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- About Us End --> */}
                        {/* <!-- About Us --> */}
                        <div className="section-full content-inner">
                            <div className="container">
                                <div className="section-head text-black text-center">                                
                                    <h2 className="box-title m-tb0">Why Choose <strong className="text-blue">whiteBing </strong>for Your Technology Partner</h2>
                                    <p>Apps we build showcase only a portion of what our mobile app development company is capable of. We know what it takes to convert your vision into reality. Having worked on numerous projects, we understand every app project is different and needs special attention. Thus, we spend a considerable time in planning and research.</p>
                                </div>
                            </div>
                            <div className="container">
                                <div className="row ">
									{iconWraper.map((data,index)=>(
										<div className="col-lg-4 col-md-6 col-sm-6 m-b30" key={index}>
											<div className="icon-bx-wraper expertise  bx-style-1 p-a30 center">
												<div className="icon-content">
													<h4 className="dlab-tilte text"><Link to={"#"}>{data.title}</Link></h4>
													<p>{data.para}</p>
													<Link to={"#"} className="site-button radius-xl outline outline-2">Read Move</Link>
												</div>
											</div>
										</div>
									))}                                    
                                </div>
                            </div>
                        </div>
                        {/* <!-- Our Services --> */}
						{/* <!-- Why Chose Us --> */}
							<SectionCounter />
                        {/* <!-- Why Chose Us End --> */}
                        {/* <!-- Testimonials --> */}
                        <div className="section-full content-inner"   style={{ backgroundImage: "url(" + bgmap + ")", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
                            <div className="container">
                                <div className="section-head text-center">
                                    <h2 className="box-title m-tb0">Our Testimonials<span className="bg-primary"></span></h2>
                                    <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the </p>
                                </div>
                                <div className="section-content m-b30 ">
									<TestimonialCarousel /> 
                                </div>
                            </div>
                        </div>
                        {/* <!-- Testimonials END --> */}
                        {/* <!-- Get in touch --> */}
                        <div className="section-full overlay-primary-dark bg-img-fix" style={{ backgroundImage: "url(" + bg1 + ")" }}>
                            <FormStyle />
                        </div>
                        {/* <!-- Get in touch --> */}
                    </div>
                    {/* <!-- contact area END --> */}
                </div>

                <Footer />
            </>
        )
    }
}
export default MobileAppDev;